'use client';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle
} from '@/components/ui/card';
import useFormattedDate from '@/hooks/useFormattedDate';
import useMixPanel from '@/hooks/useMixPanel';
import { useRouter } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import AlertSection from '../../alert/AlertSection';
import type { SaleCardVpProps } from './saleCardVp.types';

const SaleCardVp: React.FC<SaleCardVpProps> = ({ service }) => {
  const { t } = useTranslation(['bookings', 'common']);
  const { formattedDate } = useFormattedDate();
  const router = useRouter();
  const MixPanel = useMixPanel();

  const serviceInfo = service.service;
  const statusCanceled = service.status.name === 'canceled';

  const student = service.participants[0];
  const studentFullName = `${student.firstName} ${student.lastName}`;

  return (
    <Card
      className={`flex flex-col justify-between relative ${
        statusCanceled ? 'pointer-events-none' : 'cursor-pointer'
      } `}
      onClick={() => {
        MixPanel.track('press manage reservation', {
          screen: 'bookings',
          serviceName: serviceInfo.name
        });
        router.push(`/bookings/${service.id}`);
      }}
    >
      <div>
        <CardHeader className="pb-4">
          <CardTitle className="text-base">
            <p className="text-primary">{service.organization.name}</p>

            <p>{serviceInfo.name}</p>
            <p className="text-xs mt-2 text-gray-400">
              {formattedDate({ date: service.createdAt })}
            </p>
          </CardTitle>
        </CardHeader>

        <CardContent className="flex flex-col">
          <p className="text-sm text-muted-foreground  my-1 ">
            {t('bookingDetailSection.student', { name: studentFullName })}
          </p>
        </CardContent>
      </div>

      <CardFooter className="gap-2 flex flex-col">
        {statusCanceled && (
          <AlertSection
            variant="error"
            text={t('alertServicesCanceled', {
              observation: service.status.observation ?? ''
            })}
          />
        )}

        {!statusCanceled && (
          <Button className="w-full">{t('ManageReservation')}</Button>
        )}
      </CardFooter>
    </Card>
  );
};

export default SaleCardVp;
